import React, { useEffect } from 'react';
import { useDrop } from 'react-dnd';

import { ISlAnswerProps } from '../../globalInterfaces/learnEngineInterfaces';
import { RearrangeAnswerItem } from '../../../private/LearnEngineComponents/RearrangeAnswerItem/RearrangeAnswerItem';
import { DnDProviderHOC } from '../../../private/LearnEngineComponents/Common/DnDProviderHOC/DnDProviderHOC';
import { SL_REARRANGE_QUESTION } from '../../../private/LearnEngineComponents/RearrangeAnswerItem/constants';
import { AnswerOptionStatus, IAnswerOption } from '../../../../api/private/learn-engine-api/learn-engine-api.interface';

function RearrangeAnswer({
	options,
	onChange,
	isValid,
}: ISlAnswerProps): JSX.Element {
	const findCard = (id: number) => {
		const card = options.find((c) => c.id === id);
		return {
			card,
			index: options.indexOf(card),
		};
	};

	const moveCard = (id: number, atIndex: number) => {
		const from = findCard(id).index;
		const to = atIndex;
		const movedOptions: IAnswerOption[] = [...options];
		movedOptions.splice(to, 0, movedOptions.splice(from, 1)[0]);
		const result = movedOptions.map((o, index) => ({
			...o,
			status: AnswerOptionStatus.Selected,
			orderNumber: index + 1,
		}));
		isValid(true);
		onChange(result);
	};

	const [, drop] = useDrop({ accept: SL_REARRANGE_QUESTION });

	return (
		<div
			className="sl-rearrange-answer"
			sl-test-data="cmpSlRearrangeAnswer"
		>
			<div ref={drop}>
				{options.map((option: IAnswerOption) => (
					<RearrangeAnswerItem
						key={option.id}
						option={option}
						moveCard={moveCard}
						findCard={findCard}
					/>
				))}
			</div>
		</div>
	);
}

export function SlRearrangeAnswer({
	options,
	onChange,
	isValid,
}: ISlAnswerProps): JSX.Element {
	useEffect(() => {
		onChange(
			options.map((o) => ({
				...o,
				status: AnswerOptionStatus.Selected,
			})),
		);
		isValid(true);
	}, []);

	return (
		<DnDProviderHOC>
			<RearrangeAnswer
				options={options}
				isValid={isValid}
				onChange={onChange}
			/>
		</DnDProviderHOC>
	);
}
